import moment from "moment";

const getEstimatedTime = (
  orderEarliestDeliveryDeadline,
  orderLatestDeliveryDeadline
) => {
  if (orderEarliestDeliveryDeadline && orderLatestDeliveryDeadline) {
    const early = moment
      .utc(orderEarliestDeliveryDeadline)
      .local()
      .format("HH:mm");
    const latest = moment
      .utc(orderLatestDeliveryDeadline)
      .local()
      .format("HH:mm");
    return `${early} - ${latest}`;
  } else {
    return null;
  }
};

export default getEstimatedTime;
